import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./components/pages/HomePage";
import AboutPage from "./components/pages/AboutPage";
import ProgramsPage from "./components/pages/ProgramsPage";
import GovernancePage from "./components/pages/GovernancePage";
import PlatformPage from "./components/pages/PlatformPage";
import HostelDirectoryPage from "./components/pages/HostelDirectoryPage";
import DonorsPage from "./components/pages/DonorsPage";
import VendorsPage from "./components/pages/VendorsPage";
import KnowledgeHubPage from "./components/pages/KnowledgeHubPage";
import ContactPage from "./components/pages/ContactPage";
import BlogsPage from "./components/pages/BlogsPage";
import CommitteePage from "./components/pages/CommitteePage";
import ImpactTransparencyPage from "./components/pages/ImpactTransparencyPage";
import EventsPage from "./components/pages/EventsPage";
import MediaGalleryPage from "./components/pages/MediaGalleryPage";

const USER_BASE_PATH = "";

const pathToPageMap: Record<string, string> = {
  "/": "home",
  [`${USER_BASE_PATH}/about`]: "about",
  [`${USER_BASE_PATH}/committee`]: "committee",
  [`${USER_BASE_PATH}/programs`]: "programs",
  [`${USER_BASE_PATH}/governance`]: "governance",
  [`${USER_BASE_PATH}/platform`]: "platform",
  [`${USER_BASE_PATH}/hostel-directory`]: "hostel-directory",
  [`${USER_BASE_PATH}/donors`]: "donors",
  [`${USER_BASE_PATH}/vendors`]: "vendors",
  [`${USER_BASE_PATH}/knowledge-hub`]: "knowledge",
  [`${USER_BASE_PATH}/blogs`]: "blogs",
  [`${USER_BASE_PATH}/contact`]: "contact",
  [`${USER_BASE_PATH}/impact-transparency`]: "impact-transparency",
  [`${USER_BASE_PATH}/events`]: "events",
  [`${USER_BASE_PATH}/media-gallery`]: "media-gallery",
};

export default function App() {
  const location = useLocation();
  const currentPage = pathToPageMap[location.pathname] ?? "home";

  // Automatically scroll to top on navigation/page change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-[#FFF9F0]">
      <Navbar currentPage={currentPage} />
      <main className="flex-1">
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="committee" element={<CommitteePage />} />
          <Route path="programs" element={<ProgramsPage />} />
          <Route path="governance" element={<GovernancePage />} />
          <Route path="platform" element={<PlatformPage />} />
          <Route path="hostel-directory" element={<HostelDirectoryPage />} />
          <Route path="donors" element={<DonorsPage />} />
          <Route path="vendors" element={<VendorsPage />} />
          <Route path="knowledge-hub" element={<KnowledgeHubPage />} />
          <Route path="blogs" element={<BlogsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route
            path="impact-transparency"
            element={<ImpactTransparencyPage />}
          />
          <Route path="events" element={<EventsPage />} />
          <Route path="media-gallery" element={<MediaGalleryPage />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
